/** */
import React from 'react';
import styles from './section-card.module.css';

export const SectionCard = ({ title = null, action = null, children }) => (
  <div className={styles.card}>
    {title !== null && (
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        {action}
      </div>
    )}
    {children}
  </div>
);
